import { HTMLAttributes, ReactNode } from 'react';
import styles from './ProgressBar.module.scss';
import { classes } from '../../../lib/utils/cssUtils';
import { CY_COURSE_CARD_ATTRIBUTES } from '../../../lib/constants/cypress';
import { isNil } from '../../../lib/utils/isNil';

type ProgressBarProps = {
  id: string;
  progress: number;
  completeLabel?: string;
} & HTMLAttributes<HTMLDivElement>;

const ProgressBar = ({ id, progress, completeLabel, className, ...rest }: ProgressBarProps): ReactNode => {
  const idValue = `${id}-progressbar`;

  if (progress === 100 && !isNil(completeLabel)) {
    return <span className={styles.complete}>{completeLabel}</span>;
  }

  return (
    <div
      className={classes(styles.progressContainer, className)}
      {...rest}
      data-cy={CY_COURSE_CARD_ATTRIBUTES.PROGRESS}
    >
      <progress id={idValue} className={styles.progressbar} value={progress} aria-valuenow={progress} max="100" />
      <label htmlFor={idValue} className={styles.counter}>
        {progress}%
      </label>
    </div>
  );
};

export default ProgressBar;
